import IService from '../IService';

export default IService.extend({
  _getUrl: function (options) {
    return app.apiUrl(
      '/api/v1/stories/' +
        options.storyId +
        '/timelines?auto_fill_id=' +
        options.timeLineId
    );
  },

  abort: function () {
    if (app.xhrExpected(this.$ajax)) {
      this.$ajax.abort();
      this.$ajax = null;
    }
  },

  get: function (data) {
    const deferred = new $.Deferred();
    this.LastData = data;
    this.$ajax = $.ajax({
      url: this._getUrl(data),
      error: function (jqXHR) {
        deferred.reject(jqXHR);
      },
      success: function (response) {
        deferred.resolve(response);
      },
    }).always(() => {
      this.$ajax = null;
    });

    return deferred.promise();
  },
});
